import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import BannerGlobal from '../../Components/Banner/BannerGlobal'
import TeamComponent2 from '../../Components/TeamComponent/TeamComponent2'
import ContactComponent from '../../Components/ContactComponent/ContactComponent'
import useDocumentTitle from '../../PageTitle'

const Teams = () => {
  useDocumentTitle("Roofing | Teams")
  return (
    <div>
        <Header/>
        <BannerGlobal/>
        <TeamComponent2/>
        <ContactComponent/>
        <Footer/>
    </div>
  )
}

export default Teams